import React, { Component } from 'react'
import Head from 'next/head'
import { withRouter } from 'next/router'
import { get, headers } from '../../lib/fetch'
import {
  mapFiltersFromUrl,
  generateQueryString,
  convertFilters,
} from '../../lib/filterFormatter'
import { cookieValuetoJSON } from '../../lib/objectValidation'
import LayoutWithFilterAndSort from '../../components/LayoutWithFilterAndSort'
import { PAGE_TYPES } from '../../lib/eventTrackerFunction'
import { getActiveExperimentVariants } from '../../lib/getActiveExperimentVariants'
import { getIosSmartBannerContent } from '../../utils/getIosSmartBannerContent'
import { getUserType } from '../../utils/userType'
import { CTA_LOCATION_NAME } from '../../lib/amplitude'
import {
  encodeSlugIfExist,
  isEncodedURIComponent,
  setCtaLocationMeta,
} from '../../lib/utils'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import { initDyParams, setDySessionFromLayout } from '../../utils/DyUtils'
import getCanonicalUrl from '../../lib/getCanonicalUrl'

const getData = async (checkoutAddress, router, activeExperiments = '') => {
  // Calling DY for Headers
  const dyParams = initDyParams(router)

  const brandRequestUrl = `layout/brand/v2`
  const { query } = router
  const queryStringObject = {
    brand: isEncodedURIComponent(query.slug)
      ? query.slug
      : encodeSlugIfExist(query.slug),
    url: isEncodedURIComponent(query.slug)
      ? query.slug
      : encodeSlugIfExist(query.slug),
    layoutType: 'GRID',
    page: 1,
    includeTagDetails: true,
    storeId: (checkoutAddress && checkoutAddress.storeId) || null,
    orderType: getUserType(router) === 'B2B' ? 'B2B' : 'DELIVERY',
  }
  if (activeExperiments.length) {
    const { configuration } = getConfigFor(
      SPLIT_FEATURES.ALGOLIA_PERSONALISATION
    )
    const { personalisationSettings } = configuration
    queryStringObject.algopers = personalisationSettings
    queryStringObject.experiments = activeExperiments
  }

  if (query.filter) {
    const transferredFilter = mapFiltersFromUrl(query.filter)
    queryStringObject.filter = convertFilters(transferredFilter)
  }
  if (query.sorting) {
    queryStringObject.sorting = query.sorting
  }

  const api =
    brandRequestUrl + generateQueryString(queryStringObject) + dyParams
  const response = await get(api, {
    headers: headers(router),
  })

  return { data: response.data }
}
class BrandDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isStoreChanged: false,
    }
  }

  componentDidMount() {
    setDySessionFromLayout(this.props.data?.data?.page?.layouts)
    const slug = this.props.data?.data?.page?.entity?.slug
    setCtaLocationMeta([slug])
  }

  async componentDidUpdate(prevProps) {
    if (
      prevProps.checkoutAddress &&
      String(prevProps.checkoutAddress.storeId) !==
        String(this.props.checkoutAddress.storeId)
    ) {
      const activeExperiments = getActiveExperimentVariants()
      const response = await getData(
        this.props.checkoutAddress,
        this.props.router,
        activeExperiments
      )
      setDySessionFromLayout(response?.data?.page?.layouts)
      this.setState({
        storeSpecificProduct: { data: response?.data },
        isStoreChanged: true,
      })
    }

    // check for query changes to use changed data from props instead of state
    if (
      (prevProps.router.query.slug !== this.props.router.query.slug ||
        prevProps.router.query.filter !== this.props.router.query.filter ||
        prevProps.router.query.sorting !== this.props.router.query.sorting) &&
      this.state.isStoreChanged
    ) {
      this.setState({
        isStoreChanged: false,
      })
    }
  }

  render() {
    const { organizationData, categoryList, router, iosSmartBannerContent } =
      this.props

    const isStoreChanged = this.state && this.state.isStoreChanged
    const data = isStoreChanged
      ? this.state.storeSpecificProduct
      : this.props.data
    const name = data?.data?.page?.entity?.name || ''
    const slug = data?.data?.page?.entity?.slug
    const layouts = data?.data?.page?.layouts || []
    return (
      <React.Fragment>
        <Head>
          <title>{`${name} | All The Latest Products | NTUC FairPrice`}</title>
          <meta
            name="description"
            key="meta_description"
            content={`Shop for ${name} at Singapore's trusted grocery retailer.  FairPrice offers a wide range of products to choose from!`}
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content={`${name} | All The Latest Products | NTUC FairPrice`}
          />
          <meta property="og:site_name" content="FairPrice" />
          <meta name="apple-itunes-app" content={iosSmartBannerContent} />
          <link rel="canonical" href={getCanonicalUrl(router.asPath)} />
        </Head>
        <LayoutWithFilterAndSort
          title={name}
          layouts={layouts}
          organizationData={organizationData}
          preLoadFirstImage={true}
          categoryList={categoryList}
          ctaLocation={{
            pageName: CTA_LOCATION_NAME.BRAND,
            pageMeta: [slug],
          }}
          config={{
            pageType: PAGE_TYPES.BRAND,
            url: router.query.slug,
            loc: `ProductListing-${PAGE_TYPES.BRAND}`,
          }}
          filterExcept={['PWP', 'isEndlessAisle']}
        />
      </React.Fragment>
    )
  }
}

BrandDetails.getInitialProps = async ctx => {
  const iosSmartBannerContent = getIosSmartBannerContent(ctx)
  const user_type = getUserType(ctx)
  const checkoutAddress = cookieValuetoJSON(
    ctx,
    user_type === 'B2B' ? 'b2bCheckoutAddress' : 'checkoutAddress'
  )
  const activeExperiments = getActiveExperimentVariants()
  const response = await getData(checkoutAddress, ctx, activeExperiments)

  return {
    data: { data: response.data },
    iosSmartBannerContent,
  }
}

export default withRouter(BrandDetails)
